//@ts-check
import React from 'react';
import { Grid, TextField, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '../../../../../../Icon';
var fontFamilies = [{
  label: 'Inherit',
  value: 'inherit'
}, {
  label: 'Arial',
  value: 'Arial'
}, {
  label: 'Arial Black',
  value: 'Arial Black'
}, {
  label: 'Arial Nova',
  value: 'Arial Nova'
}, {
  label: 'Calisto MT',
  value: 'Calisto MT'
}, {
  label: 'Candara',
  value: 'Candara'
}, {
  label: 'Courier New',
  value: 'Courier New'
}, {
  label: 'David',
  value: 'David'
}, {
  label: 'MS UI Gothic',
  value: 'MS UI Gothic'
}, {
  label: 'Impact',
  value: 'Impact'
}, {
  label: 'Tahoma',
  value: 'Tahoma'
}, {
  label: 'Verdana',
  value: 'Verdana'
}, {
  label: 'Wingdings',
  value: 'Wingdings'
}, {
  label: 'Yu Gothic UI',
  value: 'Yu Gothic UI'
}];
var useStyles = makeStyles({
  icon: {
    fontSize: '16px'
  }
}, {
  name: 'ECFontFamilyPicker'
});

var FontFamilyPicker = function FontFamilyPicker(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? 'inherit' : _ref$value,
      onChange = _ref.onChange;
  var classes = useStyles({});
  return React.createElement(Grid, {
    container: true,
    alignItems: "center",
    wrap: "nowrap",
    spacing: 1
  }, React.createElement(Grid, {
    item: true,
    xs: 2
  }, React.createElement(Icon, {
    color: "action",
    type: "font-family",
    className: classes.icon
  })), React.createElement(Grid, {
    item: true,
    xs: 10
  }, React.createElement(TextField, {
    fullWidth: true,
    value: value,
    select: true,
    onChange: onChange
  }, fontFamilies.map(function (font) {
    return React.createElement(MenuItem, {
      key: font.value,
      value: font.value
    }, font.label);
  }))));
};

export default FontFamilyPicker;